<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import store from "@/store";
import Cookies from "js-cookie";
import "./style.scss";

export default {
  beforeCreate() {
    if (Cookies.get("token")) {
      store.dispatch("getPrivilegeList").then(() => {
        if (this.$route.path.indexOf("downOlder") === -1 && this.$route.path.indexOf("member/detail") === -1) {
          this.$router.push("/member");
        }
      });
    }
  }
};
</script>
